import styled from 'styled-components'

export default styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
`



// WEBPACK FOOTER //
// ./src/components/WidgetPicker/Main.js